<template>
  <v-button
    @click="toggleProductFromList({ product, isOnList })"
    class="addListButton"
    full-width
    has-html
    theme="lightPurple"
  >
    <svg
      :class="['addListButton__icon', { active: isOnList }]"
      :data-product-list-heart="product.id"
      height="20px"
      style="enable-background: new 0 0 23.1 20"
      version="1.1"
      viewBox="0 0 23.1 20"
      width="23.1px"
      x="0px"
      xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg"
      y="0px"
    >
      <g>
        <path
          d="M11.6,20c-0.1,0-0.3,0-0.4-0.1C10.7,19.7,0,14.6,0,6.6c0-2.5,1.5-4.8,3.7-5.9c1.6-0.8,3.4-0.9,5-0.3
		c1.1,0.4,2.1,1.1,2.9,2c1.2-1.4,3.1-2.3,5-2.3l0,0c3.6,0,6.6,2.9,6.6,6.6c0,7.2-10.6,13.1-11.1,13.3C11.9,20,11.7,20,11.6,20z
		 M6.6,2c-0.7,0-1.4,0.2-2,0.5C3,3.2,2,4.8,2,6.6c0,5.9,7.6,10.3,9.5,11.3c2-1.2,9.6-6.1,9.6-11.3c0-2.5-2-4.6-4.6-4.6l0,0l0,0
		c-1.7,0-3.3,1-4.1,2.6c-0.3,0.7-1.5,0.7-1.8,0C10.1,3.5,9.2,2.7,8,2.3C7.6,2.1,7.1,2,6.6,2z"
        />
      </g>
      <g class="addListButton__iconActive" id="active">
        <path
          d="M6.6,2c-0.7,0-1.4,0.2-2,0.5C3,3.2,2,4.8,2,6.6c0,5.9,7.6,10.3,9.5,11.3c2-1.2,9.6-6.1,9.6-11.3
		c0-2.5-2-4.6-4.6-4.6l0,0l0,0c-1.7,0-3.3,1-4.1,2.6c-0.3,0.7-1.5,0.7-1.8,0C10.1,3.5,9.2,2.7,8,2.3C7.6,2.1,7.1,2,6.6,2z"
        />
      </g>
    </svg>
    Dodaj do listy
  </v-button>
</template>

<script>
import listMixin from '~/mixins/list.js';
import VButton from '~/components/VButton';

export default {
  name: 'AddListButton',
  components: {
    VButton,
  },
  mixins: [listMixin],
  props: {
    product: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style lang="scss">
.addListButton {
  $root: &;
  &__icon {
    fill: $cMain;
    margin-right: 1rem;

    &.active {
      #{$root}__iconActive {
        opacity: 1;
      }
    }
  }

  &__iconActive {
    opacity: 0;
    transition: opacity $tr;
  }
}
</style>
